export const environment = {
  production: true,
  language: 'cs'
};
